import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrValue } from 'knockout';
import IdeationManager from 'managers/ideation';
import { IWCCStorageManager } from 'managers/iStorage';
import TopicAttachmentsManager from 'managers/topic/attachments';
import WCCAttachment from 'models/attachments/attachment';
import WCCImage from 'models/attachments/image';
import './contentImage.html';
import './contentImage.scss';

interface TopicContentImageConfig {
    topicId?: SubscribableOrValue<string | undefined>
}

@injectable()
export default class TopicContentImageVM {
    private ideationManager: Subscribable<IdeationManager | undefined>

    imageURL: Subscribable<string | undefined>

    constructor(
        @inject(wccModules.componentConfig) config: TopicContentImageConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.storage) storage: IWCCStorageManager
    ) {
        const topicId = ko.flattenComputed(config.topicId);

        this.ideationManager = storage.get(IdeationManager, { topicId });

        const attachmentsManager = storage.get(TopicAttachmentsManager, { topicId });
        const attachments = attachmentsManager.pluck(m => m.attachments, []);
        const topicContentImage = ko.pureComputed(() => this.getImage(attachments()));
        this.imageURL = topicContentImage.pluck(img => img.hqUrl);

        var isReady = ko.pureComputed(() => this.imageURL() != undefined);

        ko.applyBindingsToNode(info.element, {
            'visible': isReady,

            'css': {
                'topic-content-image': true
            }
        }, this);
    }

    getImage(attachments: Array<WCCAttachment>) {
        const ideationManager = this.ideationManager();

        if (ideationManager != undefined) {
            if (ideationManager.isIdeation() && ideationManager.isRatingStage())
                return <WCCImage | undefined>attachments.find(attachment => attachment.fileType() === enums.AttachmentTypes.IdeaRatingImage.value);
            else
                return <WCCImage | undefined>attachments.find(attachment => attachment.fileType() === enums.AttachmentTypes.ActivityInstructionsImage.value);
        }
    }
}